export default __webpack_public_path__ + "static/media/document-engage-icon.47938f4f.svg";